import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import classNames from 'classnames';
import Link from '../Link';
import Icon from '../Icon';
import { getBrandId, getSocialAuthUrl } from '../../config';
import { buildQueryString, getTimeZone } from '../../utils';
import './SocialIcons.scss';

const SocialIcons = (props, { auth: { token } }) => {
  const {
    className,
    label,
    layout,
    socialAccounts,
    socialProviders,
    affiliate,
    match: {
      params: { lang },
    },
  } = props;
  const accounts = get(socialAccounts, 'socialAccounts.data', []);
  const providers = get(socialProviders, 'options.socialProviders', []);

  const { affiliateId, btag, promo } = affiliate;

  return (
    <If condition={providers.length}>
      <nav className={classNames('media-icons', { vertical: layout === 'vertical' }, className)}>
        <If condition={label}>
          <span className="media-icons__label">{label}</span>
        </If>
        {providers.map(({ name, alias }) => {
          const providerName = name.slice(0, 2);
          const active = accounts.find(({ provider }) => provider === name);

          return (
            <Link
              key={name}
              className={classNames('media-icons__link', providerName, { active })}
              to={SocialIcons.getRedirectUrl(alias, token, { affiliateId, btag, promo, lang, timezone: getTimeZone() })}
            >
              <Icon icon={`auth-${providerName}`} />
            </Link>
          );
        })}
      </nav>
    </If>
  );
};

SocialIcons.getRedirectUrl = function getRedirectUrl(alias, token = null, extra = {}) {
  let baseUrl = `${getSocialAuthUrl()}/public${token ? '/connect' : ''}/${alias}`;
  const queryString = {
    successUrl: `${window.location.origin}/token-sign-in`,
    failureUrl: `${window.location.origin}/error`,
    ...extra,
  };

  if (!token) {
    baseUrl = `${baseUrl}/${getBrandId()}`;
  } else {
    queryString.token = token;
    queryString.successUrl = `${window.location.origin}/player/profile`;
    queryString.failureUrl = `${window.location.origin}/player/profile`;
  }

  return `${baseUrl}?${buildQueryString(queryString)}`;
};

SocialIcons.propTypes = {
  socialProviders: PropTypes.shape({
    loading: PropTypes.bool,
    options: PropTypes.shape({
      socialProviders: PropTypes.arrayOf(
        PropTypes.shape({
          alias: PropTypes.string,
          name: PropTypes.string,
        })
      ),
    }),
  }).isRequired,
  socialAccounts: PropTypes.shape({
    loading: PropTypes.bool,
    socialAccounts: PropTypes.shape({
      data: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
          provider: PropTypes.string,
        })
      ),
    }),
  }),
  label: PropTypes.string,
  layout: PropTypes.oneOf(['horizontal', 'vertical']),
  className: PropTypes.string,
  affiliate: PropTypes.object,
  match: PropTypes.shape({
    params: PropTypes.shape({
      lang: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

SocialIcons.contextTypes = {
  auth: PropTypes.shape({
    token: PropTypes.string,
  }),
};

SocialIcons.defaultProps = {
  label: null,
  layout: 'horizontal',
  socialAccounts: {
    loading: false,
    socialAccounts: {
      data: [],
    },
  },
  className: null,
};

export default SocialIcons;
